import { Component } from "@angular/core";

@Component({
    selector: "app-highlight",
    templateUrl: "./highlight.component.html",
    styleUrl: "./highlight.component.scss",
    standalone: false,
})
export class HighlightComponent {}
